import {
  Component,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  Inject,
} from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { AppService } from "src/_services/app.service";
import { Router, ActivatedRoute } from "@angular/router";
import { MatPaginator, MatDatepickerInputEvent } from "@angular/material";
import * as moment from "moment";
import { AuthenticationService } from "src/_services/authentication.service";

export interface DialogData {
  eventId: string;
  sportId: string;
  providerId: string;
  marketId: string;
  marketName: string;
  marketType: string;
  rollbackType: string;
}

@Component({
  selector: "app-market-settlements",
  templateUrl: "./market-settlements.component.html",
  styleUrls: ["./market-settlements.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class MarketSettlementsComponent implements OnInit {
  providers: any = [];
  providerId;
  eventId = "";
  eventName = "";
  sportsList = [];
  sportId;
  status = "";
  searchKey = "";
  selectedStatus = "";
  searchWord: string = "";
  sportName: string = "";
  openDate = 0;
  selectedRunnerName = "";
  filteredOpenMarkets = [];
  openMarkets = [];
  filteredMappedMarkets = [];
  mappedMarkets = [];
  filteredInprogressMarkets = [];
  inprogressMarkets = [];
  filteredSettledMarkets = [];
  settledMarkets = [];
  filteredVoidedMarkets = [];
  voidedMarkets = [];
  startDate: null;
  endDate: null;

  openMarketsTableColumns = [
    "Created At",
    "Market Id",
    "Market Name",
    "Select Runner",
    "Open Bets",
    "Result",
    "Actions",
  ];
  mappedMarketsTableColumns = [
    "Created At",
    "Market Id",
    "Market Name",
    // "Selected Runner",
    "Result",
    "Actions",
  ];
  inprogressMarketsColumns = [
    "Created At",
    "Market Id",
    "Market Name",
    "Result",
  ];
  settledMarketColums = [
    "Created At",
    "Market Id",
    "Market Name",
    "Result",
    "Actions",
  ];
  voidedMarketColumns = ["Created At", "Market Id", "Market Name", "Actions"];

  constructor(
    private appService: AppService,
    private router: Router,
    private activetedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private authenticationService: AuthenticationService,
  ) {}

  ngOnInit() {
    this.activetedRoute.queryParams.subscribe((params) => {
      this.providerId = params["providerId"];
      this.sportId = params["sportId"];
      this.eventId = params["eventId"];
      this.eventName = params["eventName"];
      this.sportName = params["sportName"];
      this.openDate = parseInt(params["openDate"]);
      this.startDate  = params["startDate"]
      this.endDate  = params["endDate"]
    });

    this.getEvetDetails();
  }

  getEvetDetails() {
    try {
      this.appService
        .getEventsDetailsForSettlemets(
          this.eventId,
          this.sportId,
          this.providerId
        )
        .subscribe((response) => {
          if (response.status === "RS_OK") {
            let marketsList = [];
            let openMarketsList = [];
            let mappedMarketsList = [];
            let inprogressMarketsList = [];
            let settledMarketsList = [];
            let voidedMarketsList = [];
            marketsList = response.markets.sort((a, b) => {
              // if (b.openBets !== a.openBets) {
              //     return b.openBets - a.openBets;
              // }
              return a.marketName.localeCompare(b.marketName);
          });
            marketsList.forEach((market) => {
              if (
                market.marketStatus.toLowerCase() === "open" || market.marketStatus === "SETTLEMENT_HOLD" ||
                market.marketStatus === "" || market.marketStatus.toLowerCase() === "suspended"
              ) {
                openMarketsList.push({
                  ...market,
                  isDisabled: true,
                  selectedRunner: "",
                  sessionOutcome: "",
                });
              } else if (market.marketStatus.toLowerCase() === "mapped") {
                mappedMarketsList.push({
                  ...market,
                  isDisabled: true,
                  selectedRunner: "",
                  sessionOutcome: "",
                });
              } else if (market.marketStatus.toLowerCase() === "settled" ||
                (market.marketStatus.toLowerCase() === "closed" && this.providerId === "BetFair")
              ) {
                settledMarketsList.push({
                  ...market,
                  isDisabled: true,
                  selectedRunner: "",
                  sessionOutcome: "",
                });
              } else if (market.marketStatus.toLowerCase() === "voided") {
                voidedMarketsList.push({
                  ...market,
                  isDisabled: true,
                  selectedRunner: "",
                  sessionOutcome: "",
                });
              } else {
                inprogressMarketsList.push({
                  ...market,
                  isDisabled: true,
                  selectedRunner: "",
                  sessionOutcome: "",
                });
              }
            });
            this.filteredOpenMarkets = openMarketsList;
            this.openMarkets = openMarketsList;
            this.filteredMappedMarkets = mappedMarketsList;
            this.mappedMarkets = mappedMarketsList;
            this.inprogressMarkets = inprogressMarketsList;
            this.filteredInprogressMarkets = inprogressMarketsList;
            this.settledMarkets = settledMarketsList;
            this.filteredSettledMarkets = settledMarketsList;
            this.filteredVoidedMarkets = voidedMarketsList;
            this.voidedMarkets = voidedMarketsList;
          }
        });
    } catch (err) {
      console.log(err);
    }
  }
  onSelectedStatusChange(status) {
    this.searchKey = "";
    this.status = status;
    console.log("status", status);
  }

  searchHandlerChange() {
    if (this.status === "Mapped") {
      if (this.searchKey.length >= 1) {
        this.filteredMappedMarkets = this.mappedMarkets.filter((market) => {
          if (
            market.marketName
              .toLocaleLowerCase()
              .includes(this.searchKey.toLocaleLowerCase())
          ) {
            return market;
          }
        });
      } else {
        this.filteredMappedMarkets = this.mappedMarkets;
      }
    } else if (this.status === "In Progress") {
      if (this.searchKey.length >= 1) {
        this.filteredInprogressMarkets = this.inprogressMarkets.filter(
          (market) => {
            if (
              market.marketName
                .toLocaleLowerCase()
                .includes(this.searchKey.toLocaleLowerCase())
            ) {
              return market;
            }
          }
        );
      } else {
        this.filteredInprogressMarkets = this.inprogressMarkets;
      }
    } else if (this.status === "Settled") {
      if (this.searchKey.length >= 1) {
        this.filteredSettledMarkets = this.settledMarkets.filter((market) => {
          if (
            market.marketName
              .toLocaleLowerCase()
              .includes(this.searchKey.toLocaleLowerCase())
          ) {
            return market;
          }
        });
      } else {
        this.filteredSettledMarkets = this.settledMarkets;
      }
    } else if (this.status === "Voided") {
      if (this.searchKey.length >= 1) {
        this.filteredVoidedMarkets = this.voidedMarkets.filter((market) => {
          if (
            market.marketName
              .toLocaleLowerCase()
              .includes(this.searchKey.toLocaleLowerCase())
          ) {
            return market;
          }
        });
      } else {
        this.filteredVoidedMarkets = this.voidedMarkets;
      }
    } else {
      if (this.searchKey.length >= 1) {
        this.filteredOpenMarkets = this.openMarkets.filter((market) => {
          if (
            market.marketName
              .toLocaleLowerCase()
              .includes(this.searchKey.toLocaleLowerCase())
          ) {
            return market;
          }
        });
      } else {
        this.filteredOpenMarkets = this.openMarkets;
      }
    }
  }

  onSelectingRunner(runner, index) {
    this.filteredOpenMarkets[index] = {
      ...this.filteredOpenMarkets[index],
      isDisabled: false,
      selectedRunnerId: runner.runnerId,
      selectedRunner: runner.runnerName,
    };

    this.selectedRunnerName = runner.runnerName;
  }

  onChangingSessionOutcome(sessionOutcome, index) {
    this.filteredOpenMarkets[index] = {
      ...this.filteredOpenMarkets[index],
      isDisabled: sessionOutcome ? false : true,
      sessionOutcome: sessionOutcome,
    };
  }

  confirmHoldSettlement(market, index) {
    let marketItem = this.filteredOpenMarkets[index];
    if (marketItem.marketStatus === "SETTLEMENT_HOLD") {
      try {
        let dialogRef = this.dialog.open(HoldConfirmModal, {
          backdropClass: "backdropBackground",
          hasBackdrop: true,
          data: {},
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            this.setMarkettoMap(market, index);
          }
        });
      } catch (err) {
        console.log(err);
        this.authenticationService.openErrorSnackBar("invalid");
      }

    } else {
      this.setMarkettoMap(market, index);
    }
  }

  setMarkettoMap(market, index) {
    let marketItem = this.filteredOpenMarkets[index];
    console.log(marketItem, "Market Iteam to be mapped!!");
    try {
      this.appService
        .mapMarkets(
          marketItem.eventId,
          marketItem.sportId,
          marketItem.providerId,
          marketItem.marketId,
          marketItem.selectedRunnerId,
          marketItem.selectedRunner,
          marketItem.sessionOutcome
        )
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.getEvetDetails();
          } else {
            this.authenticationService.openErrorSnackBar(res.errorDescription);
            if (res.errorDescription === "Invalid Token!") {
              sessionStorage.clear();
            }
          }
        });
    } catch (err) {}
  }

  setMarketToVoid(market, rollBackType) {
        let dialogRef = this.dialog.open(SettlementMarketsModal, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        eventId: market.eventId,
        sportId: market.sportId,
        providerId: market.providerId,
        marketId: market.marketId,
        marketName: market.marketName,
        marketType: market.marketType,
        rollbackType: rollBackType,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.getEvetDetails();
    });
  }

  setMarketToSettle(market) {
    try {
      this.appService
        .setMarketToSettle(
          market.eventId,
          market.sportId,
          market.providerId,
          market.marketId,
          market.results[market.results.length - 1].runnerId,
          market.results[market.results.length - 1].runnerName,
          market.results[market.results.length - 1].sessionOutcome
        )
        .subscribe((res) => {
          console.log(res);
          if (res.status === "RS_OK") {
            this.getEvetDetails();
          }
        });
    } catch (err) {}
  }

  setMarketToHold(market) {
    try {
      let filters = {
        eventId: market.eventId,
        sportId: market.sportId,
        providerId: market.providerId,
        marketId: market.marketId
      }
      this.appService
        .holdMarket(
          filters
        )
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar(res.errorDescription)
            this.getEvetDetails();
          } else {
            this.appService.openErrorBar(res.errorDescription)
          }
        });
    } catch (err) {}
  }

  setMarketToOpen(market) {
    try {
      this.appService
        .setMarketToOpen(
          market.eventId,
          market.sportId,
          market.providerId,
          market.marketId
        )
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.getEvetDetails();
          } else {
            if (res.errorDescription === "Invalid Token!") {
              sessionStorage.clear();
            }
          }
        });
    } catch (err) {}
  }

  gotoBetLevelSettlement(market,status) {
    console.log(market)
    this.router.navigate(["/bet-settlement"], {
      queryParams: {
        providerId: market.providerId,
        sportId: market.sportId,
        sportName: market.sportName,
        eventId: market.eventId,
        openDate: this.openDate,
        marketId: market.marketId,
        marketName: market.marketName,
        marketType: market.marketType,
        eventName: market.eventName,
        status: status,
      },
    });
  }

  gotoMarketBetLevelSettlement(market,status) {
    this.router.navigate(["/market-bet-settlement"], {
      queryParams: {
        providerId: market.providerId,
        sportId: market.sportId,
        sportName: market.sportName,
        eventId: market.eventId,
        openDate: this.openDate,
        marketId: market.marketId,
        marketName: market.marketName,
        marketType: market.marketType,
        eventName: market.eventName,
        status: status,
      },
    });
  }

  goBack() {
    this.router.navigate(["settlements-events"], {
      queryParams: {
        providerId: this.providerId,
        sportId: this.sportId,
        sportName: this.sportName,
        startDate: this.startDate,
        endDate: this.endDate,
      },
    });
  }

  convertDate(timeISeconds) {
    let date = timeISeconds * 1000;
    return moment(date).format("DD MMM YYYY hh:mm:ss A");
  }

  convertopenDate(date) {
    return moment(date).format("DD MMM YYYY hh:mm:ss A");
  }

  onKeyDown(event: KeyboardEvent) {
    // Prevent 'e', '-', and '+' key inputs
    if (event.key === 'e' || event.key === '-' || event.key === '+') {
      event.preventDefault();
    }
  }
}

@Component({
  selector: "dialog-overview-example-dialog",
  templateUrl: "./hold-confirm-modal.html",
  styleUrls: ["./market-settlements.component.scss"],
})
export class HoldConfirmModal {
  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  confirm() {
    this.dialogRef.close(true);
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}

@Component({
  selector: "dialog-overview-example-dialog",
  templateUrl: "./market-settlement-void-modal.html",
  styleUrls: ["./market-settlements.component.scss"],
})
export class SettlementMarketsModal {
  reason: string = "";
  disabledStatus = true;
  constructor(
    private appService: AppService,
    private authenticationService: AuthenticationService,
    public dialogRef: MatDialogRef<SettlementMarketsModal>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  onChangeTheReason(event) {
        this.reason = event.target.value;
    if (this.reason.length > 0) {
      this.disabledStatus = false;
    } else {
      this.disabledStatus = true;
    }
  }

  voidTheMarket() {
    // if (this.data.rollbackType.toLowerCase() === "settled void") {
    //   try {
    //     this.appService
    //       .SetMarketToVoid(
    //         this.data.eventId,
    //         this.data.sportId,
    //         this.data.providerId,
    //         this.data.marketId,
    //         this.data.marketName,
    //         this.data.marketType,
    //         "Rollback",
    //         this.reason
    //       )
    //       .subscribe((response) => {
    //         if (response.status === "RS_OK") {
    //           this.appService
    //             .SetMarketToVoid(
    //               this.data.eventId,
    //               this.data.sportId,
    //               this.data.providerId,
    //               this.data.marketId,
    //               this.data.marketName,
    //               this.data.marketType,
    //               "Void",
    //               this.reason
    //             )
    //             .subscribe((response) => {
    //               if (response.status === "RS_OK") {
    //                 this.dialogRef.close();
    //               }
    //             });
    //           this.dialogRef.close();
    //         }
    //       });
    //   } catch (err) {
    //     console.log(err);
    //   }
    // } else {
      try {
        this.appService
          .SetMarketToVoid(
            this.data.eventId,
            this.data.sportId,
            this.data.providerId,
            this.data.marketId,
            this.data.marketName,
            this.data.marketType,
            this.data.rollbackType,
            this.reason
          )
          .subscribe((response) => {
            this.dialogRef.close();
            if (response.status === "RS_OK") {
            } else {
              this.authenticationService.openErrorSnackBar(response.errorDescription);
            }
          });
      } catch (err) {
        console.log(err);
      }
    // }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}
